import React, { useEffect } from "react";
import CommentElement from "./CommentElement.js";
import { useComments } from "../../../../contexts/commentsContext/commentsContext.js";

const CommentsStructure = ({ itemId }) => {
  const { getAllCommentsData } = useComments();
  const commentsList = itemId
    ? Object.keys(getAllCommentsData()).filter(
        (id) => getAllCommentsData()[id].RelevantFile == itemId
      )
    : Object.keys(getAllCommentsData());

  // useEffect(() => {
  //   document.querySelector(
  //     ".comments-container"
  //   ).scrollTop = document.querySelector(".comments-container").scrollHeight;
  // }, [getAllCommentsData()]);

  return (
    <div className="comments-container">
      {commentsList.map((commentId) => {
        const childrenList = Object.keys(getAllCommentsData()).filter(
          (id) => getAllCommentsData()[id].Parent == commentId
        );
        return !getAllCommentsData()[commentId].Parent ? (
          <div key={commentId}>
            <CommentElement id={commentId} {...{ itemId }}>
              {childrenList.map((nestedCommentId) => {
                return (
                  <CommentElement
                    key={nestedCommentId}
                    id={nestedCommentId}
                    {...{
                      itemId,
                    }}
                  />
                );
              })}
            </CommentElement>
            <div className="horizontal-divider"></div>
          </div>
        ) : null;
      })}
    </div>
  );
};

export default CommentsStructure;
